import { HelmetProvider } from 'react-helmet-async'

export default function AppHelmetProvider({ children }) {
  return <HelmetProvider>{children}</HelmetProvider>
}